module.exports = __webpack_public_path__ + "static/media/Picto_A-propos_AltyorHub.e43a746b.svg";